/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { Grid, Typography, withStyles, Fade } from '@material-ui/core';

import ReactGA from 'react-ga';
import SectionHeader from '../../components/SectionHeader';
import Asset from '../../components/Asset';

const styles = theme => ({
  manual: {
    backgroundColor: theme.palette.white
    // backgroundImage: 'url(images/bg2.png)'
  },
  manualImg: {
    border: `1px solid ${theme.palette.grey[400]}`,
    '&:hover': {
      boxShadow: `0 0 5px  ${theme.palette.grey[400]}`
    }
  },
  manualText: {
    textDecoration: 'none'
  }
});

const Manual = class extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <section className={classes.manual}>
        <div className="wrapper">
          <SectionHeader
            color="primary"
            text="manual"
            subtitle='aka "What is this game about?"'
            subcolor="secondary"
            img={19}
            imgHeight={42}
          />
          <Grid container spacing={24} alignContent="center">
            <Grid item xs={12} sm>
              <Typography paragraph variant="body1">
                You don't yet have our game, but what you've heard so far piqued
                your interest? You wonder, perhaps, how it feels to play our
                game? Well then, put your imagination into overdrive and take a
                look at our manual. <Asset img={12} /> It will give you a
                feeling of what it means to play SoftWar without, you know,
                actually playing it. It's also probably the only way to
                experience SoftWar safely without risk of losing friends, so
                reading it is a no-brainer, really. <Asset img={23} />
              </Typography>
            </Grid>
            <Grid item md={4} xs={12}>
              <div style={{ textAlign: 'center' }}>
                <Fade in timeout={1000}>
                  <a
                    href="/softwar-manual.pdf"
                    download="SoftWar Manual.pdf"
                    onClick={() => {
                      ReactGA.ga(
                        'send',
                        'event',
                        'manual',
                        'clicked',
                        'download'
                      );
                    }}
                    className={classes.manualText}
                  >
                    <img
                      className={classes.manualImg}
                      src="images/manual.jpg"
                      alt="SoftWar Manual"
                    />
                    <Typography
                      className={classes.manualText}
                      variant="subtitle2"
                    >
                      Download [27 MB]
                    </Typography>
                  </a>
                </Fade>
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(Manual);
